import { Button, Input, Modal } from '@mui/joy'
import React, { useState, Dispatch, SetStateAction, useEffect } from 'react'
import { BASE_URL, BLACK, PRIMARY, WHITE } from '../../../appConstants'
import appError from '../../../appError';
import Joi from "joi";
import axios from 'axios';
import toast from 'react-hot-toast';

type FlipkartAddModalProps = {
    callGetAPI: () => void;
    setToggleModal: Dispatch<SetStateAction<boolean>>;
    brand_id: string;
    modal_name: string;
    platform_id: string;
    platformType: string;
}

type InputStateProps = {
    sellerId: string;
    email: string;
    password: string;
    forwardEmailAddress: string;
    panelName: string;
    aAccount: string;
    bAccount: string;
}

const FlipkartAddModal:React.FC<FlipkartAddModalProps> = ({
    callGetAPI,
    setToggleModal,
    brand_id,
    modal_name, 
    platform_id,
    platformType
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [inputState, setInputState] = useState<InputStateProps>({
        sellerId: '',
        email:'',
        password: "",
        forwardEmailAddress: "",
        panelName: "",
        aAccount: "",
        bAccount: ""
    });

    const areAllFieldsEmpty = (state: InputStateProps) => {
        // Get an array of all values from the object
        const values = Object.values(state);
      
        // Check if any value is not an empty string or null/undefined.
        // We trim the string to handle cases with only whitespace.
        const hasNonEmptyValue = values.some(value => {
          if (typeof value === 'string') {
            return value.trim() !== '';
          }
          return value !== null && typeof value !== 'undefined';
        });
      
        // Return true if none of the values were non-empty
        return !hasNonEmptyValue;
      };

    const onChangeHandler = ({ target: { value, name } }: React.ChangeEvent<HTMLInputElement>): void => {
      setInputState((prev) => ({
        ...prev,
        [name]: value
      }));
    }

    const onSubmitHandler = async(ag_inputState: InputStateProps, ag_brand_id: string, ag_modal_name: string, ag_platformId: string, ag_platformType: string) => {
        const schema = ag_platformType === "Flipkart Sales API" ? Joi.object({
            sellerId: Joi.string().required(),
            email: Joi.string().required().email({ tlds: { allow: false } }),
            password: Joi.string().required(),
            forwardEmailAddress: Joi.string().required().email({ tlds: { allow: false } }),
            panelName: Joi.string().required(),
        }) : Joi.object({
            email: Joi.string().required().email({ tlds: { allow: false } }),
            password: Joi.string().required(),
            forwardEmailAddress: Joi.string().required().email({ tlds: { allow: false } }),
            aAccount: Joi.string().required(),
            bAccount: Joi.string().required()
        });

        const {sellerId, email, password, forwardEmailAddress, panelName, aAccount, bAccount} = ag_inputState;
        const input = ag_platformType === "Flipkart Sales API" ? {sellerId, email, password, forwardEmailAddress, panelName} : {email, password, forwardEmailAddress, aAccount, bAccount};
        const validate = schema.validate(input);
        if (validate.error) {
            appError(validate.error);
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const res = await axios.post(
                `${BASE_URL}apiAccess/addAccessedProfileIdsFlipkart?brand_id=${brand_id}&platform_id=${ag_platformId}&platform_type=${ag_platformType}`,
                {
                    ...validate.value
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

            if(res.data.status === "success"){
                toast.success(`${modal_name} ${res.data.message}`);
                callGetAPI();
                setToggleModal(false);
            }

        } catch (error) {
            appError(error);
        } finally {
            setLoading(false);
        }
    }

  return (
    <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        > 
        <div style={{
            height: 474,
            width: 700,
            backgroundColor: WHITE.W_100,
            borderRadius: 18,
            padding: 40,
            display: "flex",
            flexDirection: "column",
            gap: "40px",
            justifyContent: "space-between"
          }}>
            <div className="flex flex-col w-full">
                <div
                  className="self-stretch"
                  style={{
                    color: `${BLACK.B_100}`,
                    fontSize: 16,
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                  }}
                >
                  Add {modal_name} 
                </div>
                <div
                  className="self-stetch"
                  style={{
                    color: `${BLACK.B_40}`,
                    fontSize: 12,
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  Assign Token ID below
                </div>
              </div>

            <div className="flex flex-wrap justify-between gap-4">
                <div className="w-[48%] flex flex-col gap-[4px]">
                    <div
                        className="flex flex-col h-[20px] justify-center self-stretch"
                        style={{
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "20px",
                        color:"#5B5B5B"

                        }}
                    >
                        Enter Email :
                    </div>
                    <Input
                        placeholder="Enter the Email ID"
                        sx={{
                            "--Input-focusedThickness": "0px",
                            width: "100%",
                            height: "40px",
                            backgroundColor: BLACK.B_5
                        }}
                        name="email"
                        value={inputState.email}
                        type="email"
                        onChange={onChangeHandler}
                    />
                </div>

                <div className="w-[48%] flex flex-col gap-[4px]">
                    <div
                        className="flex flex-col h-[20px] justify-center self-stretch"
                        style={{
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "20px",
                        color:"#5B5B5B"

                        }}
                    >
                        Enter Password :
                    </div>
                    <Input
                        placeholder="Enter the Password"
                        sx={{
                            "--Input-focusedThickness": "0px",
                            width: "100%",
                            height: "40px",
                            backgroundColor: BLACK.B_5
                        }}
                        name="password"
                        value={inputState.password}
                        type="password"
                        onChange={onChangeHandler}
                    />
                </div>

                <div className="w-[48%] flex flex-col gap-[4px]">
                    <div
                        className="flex flex-col h-[20px] justify-center self-stretch"
                        style={{
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "20px",
                        color:"#5B5B5B"

                        }}
                    >
                        Enter Forwarded Email :
                    </div>
                    <Input
                        placeholder="Enter the Forwarded Email"
                        sx={{
                            "--Input-focusedThickness": "0px",
                            width: "100%",
                            height: "40px",
                            backgroundColor: BLACK.B_5
                        }}
                        name="forwardEmailAddress"
                        value={inputState.forwardEmailAddress}
                        type="email"
                        onChange={onChangeHandler}
                    />
                </div>

                {modal_name === "Seller" && (
                    <div className="w-[48%] flex flex-col gap-[4px]">
                        <div
                            className="flex flex-col h-[20px] justify-center self-stretch"
                            style={{
                            fontSize: 14,
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            color:"#5B5B5B"

                            }}
                        >
                            Enter Seller ID :
                        </div>
                        <Input
                            placeholder="Enter the Seller ID"
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "40px",
                                backgroundColor: BLACK.B_5
                            }}
                            name="sellerId"
                            value={inputState.sellerId}
                            onChange={onChangeHandler}
                        />
                    </div>
                )}

                {modal_name === "Seller" && (
                    <div className="w-[48%] flex flex-col gap-[4px]">
                        <div
                            className="flex flex-col h-[20px] justify-center self-stretch"
                            style={{
                            fontSize: 14,
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            color:"#5B5B5B"

                            }}
                        >
                            Enter Panel Name :
                        </div>
                        <Input
                            placeholder="Enter the Panel Name"
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "40px",
                                backgroundColor: BLACK.B_5
                            }}
                            name="panelName"
                            value={inputState.panelName}
                            onChange={onChangeHandler}
                        />
                    </div>
                )}

                {(modal_name === "Seller Ads" || modal_name === "Ads" )&& (
                    <div className="w-[48%] flex flex-col gap-[4px]">
                        <div
                            className="flex flex-col h-[20px] justify-center self-stretch"
                            style={{
                            fontSize: 14,
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            color:"#5B5B5B"

                            }}
                        >
                            Enter A Account :
                        </div>
                        <Input
                            placeholder="Enter the A Account"
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "40px",
                                backgroundColor: BLACK.B_5
                            }}
                            name="aAccount"
                            value={inputState.aAccount}
                            onChange={onChangeHandler}
                        />
                    </div>
                )}

                {(modal_name === "Seller Ads" || modal_name === "Ads") && (
                    <div className="w-[48%] flex flex-col gap-[4px]">
                        <div
                            className="flex flex-col h-[20px] justify-center self-stretch"
                            style={{
                            fontSize: 14,
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "20px",
                            color:"#5B5B5B"

                            }}
                        >
                            Enter B Account :
                        </div>
                        <Input
                            placeholder="Enter the B Account"
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "100%",
                                height: "40px",
                                backgroundColor: BLACK.B_5
                            }}
                            name="bAccount"
                            value={inputState.bAccount}
                            onChange={onChangeHandler}
                        />
                    </div>
                )}
            </div>

            <div className="flex flex-row justify-between gap-4">
              <Button
                color="neutral"
                sx={{
                  height: "48px",
                  width: "50%",
                  backgroundColor: BLACK.B_5,
                  color: BLACK.B_100,
                  ":hover": {
                    backgroundColor: BLACK.B_20,
                  },
                }}
                onClick={()=>setToggleModal(false)}
              >
                Cancel
              </Button>
              <Button
                loading={loading}
                onClick={() => onSubmitHandler(inputState, brand_id, modal_name, platform_id, platformType)}
                disabled={areAllFieldsEmpty(inputState)}
                sx={{
                  height: "48px",
                  width: "50%",
                  backgroundColor: PRIMARY.P_BLue,
                }}
              >
                Submit
              </Button>
            </div>
        </div>       
      </Modal>
  )
}

export default FlipkartAddModal